"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var object_importer_render_1 = __importDefault(require("../utils/object-importer-render"));
var Renderer = /** @class */ (function () {
    function Renderer() {
        var _this = this;
        this.renderLayer = function (layer, params) {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var staticCanvas, toDataOptions, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            staticCanvas = new fabric_1.fabric.StaticCanvas(null);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, this.loadTemplate(staticCanvas, {
                                    id: layer.id,
                                    metadata: {},
                                    layers: [__assign(__assign({}, layer), { top: 0, left: 0 })],
                                    frame: {
                                        width: layer.width * layer.scaleX,
                                        height: layer.height * layer.scaleY,
                                    },
                                }, params)];
                        case 2:
                            _a.sent();
                            toDataOptions = __assign({ top: 0, left: 0, height: staticCanvas.getHeight(), width: staticCanvas.getWidth() }, params);
                            if (toDataOptions.pixelRatio) {
                                toDataOptions.multiplier = toDataOptions.pixelRatio;
                                delete toDataOptions.pixelRatio;
                            }
                            data = staticCanvas.toDataURL(toDataOptions);
                            resolve(data);
                            return [3 /*break*/, 4];
                        case 3:
                            staticCanvas.dispose();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
    }
    Renderer.prototype.render = function (template, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.toDataURL(template, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Renderer.prototype.toDataURL = function (template, params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var staticCanvas, toDataOptions, data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    staticCanvas = new fabric_1.fabric.StaticCanvas(null);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, , 3, 4]);
                                    return [4 /*yield*/, this.loadTemplate(staticCanvas, template, params)];
                                case 2:
                                    _a.sent();
                                    toDataOptions = __assign({ top: 0, left: 0, height: staticCanvas.getHeight(), width: staticCanvas.getWidth() }, params);
                                    if (toDataOptions.pixelRatio) {
                                        toDataOptions.multiplier = toDataOptions.pixelRatio;
                                        delete toDataOptions.pixelRatio;
                                    }
                                    data = staticCanvas.toDataURL(toDataOptions);
                                    resolve(data);
                                    return [3 /*break*/, 4];
                                case 3:
                                    staticCanvas.dispose();
                                    return [7 /*endfinally*/];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * Non-blocking alternative to render() / toDataURL().
     * Uses canvas.toBlob() which runs the heavy PNG/JPEG encoding on the
     * browser's internal thread, keeping the main thread (and UI) responsive.
     */
    Renderer.prototype.renderToBlob = function (template, params) {
        var _a;
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var staticCanvas, mimeType, quality, multiplier, canvasEl, tmpCanvas, sourceEl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        staticCanvas = new fabric_1.fabric.StaticCanvas(null);
                        return [4 /*yield*/, this.loadTemplate(staticCanvas, template, params)];
                    case 1:
                        _b.sent();
                        mimeType = params.format || 'image/png';
                        quality = (_a = params.quality) !== null && _a !== void 0 ? _a : 1.0;
                        multiplier = params.pixelRatio || 1;
                        canvasEl = staticCanvas.getElement();
                        tmpCanvas = null;
                        sourceEl = multiplier !== 1
                            ? (function () {
                                tmpCanvas = document.createElement('canvas');
                                tmpCanvas.width = Math.round(staticCanvas.getWidth() * multiplier);
                                tmpCanvas.height = Math.round(staticCanvas.getHeight() * multiplier);
                                var ctx = tmpCanvas.getContext('2d');
                                ctx.drawImage(canvasEl, 0, 0, tmpCanvas.width, tmpCanvas.height);
                                return tmpCanvas;
                            })()
                            : canvasEl;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, , 4, 5]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                sourceEl.toBlob(function (blob) {
                                    if (blob)
                                        resolve(blob);
                                    else
                                        reject(new Error('canvas.toBlob() returned null'));
                                }, mimeType, quality);
                            })];
                    case 3: return [2 /*return*/, _b.sent()];
                    case 4:
                        // Release canvas backing stores to free memory
                        staticCanvas.dispose();
                        if (tmpCanvas) {
                            tmpCanvas.width = 0;
                            tmpCanvas.height = 0;
                            tmpCanvas = null;
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Renderer.prototype.loadTemplate = function (staticCanvas, template, params) {
        return __awaiter(this, void 0, void 0, function () {
            var frame, objectImporter, _a, _b, layer, element, err_1, e_1_1;
            var e_1, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        frame = template.frame;
                        this.setDimensions(staticCanvas, frame);
                        objectImporter = new object_importer_render_1.default();
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 10, 11, 12]);
                        _a = __values(template.layers), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 9];
                        layer = _b.value;
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, objectImporter.import(layer, params)];
                    case 4:
                        element = _d.sent();
                        if (element) {
                            staticCanvas.add(element);
                        }
                        else {
                            console.log("UNABLE TO LOAD LAYER: ", layer);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _d.sent();
                        console.warn('Error importing layer', layer && layer.id, err_1);
                        return [3 /*break*/, 6];
                    case 6: 
                    // Yield to the browser so rendering and user input stay responsive.
                    return [4 /*yield*/, new Promise(function (resolve) { return requestAnimationFrame(resolve); })];
                    case 7:
                        // Yield to the browser so rendering and user input stay responsive.
                        _d.sent();
                        _d.label = 8;
                    case 8:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 12];
                    case 11:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    Renderer.prototype.setDimensions = function (staticCanvas, _a) {
        var width = _a.width, height = _a.height;
        staticCanvas.setWidth(width).setHeight(height);
    };
    return Renderer;
}());
exports.default = Renderer;
//# sourceMappingURL=Renderer.js.map